import Header from './components/Header';
import HeroSection from './components/HeroSection';
import { CommentsSection, CardsSection, RankingSection, TopicsSection } from './components/SectionsA';
import { AboutSection, UpdatesSection, FAQSection, ContactSection } from './components/SectionsB';
import { MediaSection, AppSection, CarouselSection, FeaturesSection, IndexSection } from './components/SectionsC';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <HeroSection />
      <main>
        <CommentsSection />
        <CardsSection />
        <RankingSection />
        <TopicsSection />
        <AboutSection />
        <UpdatesSection />
        <FAQSection />
        <ContactSection />
        <MediaSection />
        <AppSection />
        <CarouselSection />
        <FeaturesSection />
        <IndexSection />
      </main>
      <Footer />
    </div>
  );
}